/* =Связанные документы=========================================================================================================================== */
function LoadSubRelations(type, obj, id, refcode, filter, additional) {
  $.ajax({
    type: "GET",
    dataType: "html",
    url: "DynControl.ashx?c=" + type + "&id=" + id + "&refcode=" + refcode + "&filter=" + filter + '&additional=' + additional,
    success: function (res) {
      if (!CheckForLoginPage(res)) {
        obj.html(res);
        var list = obj.find('.List');
        InitHover(list);
        InitListClick(list);
        if (WA.ObjectListInit.state() === "resolved" && !!WA.CR.objectList) WA.CR.objectList.fire("itemsChange");
      }
    }
  });
}

function ShowRelations(type, obj) {
  var tr = $(obj).parent();

  var filter;
  var tbl = tr.parent();
  var tblID = tbl.attr('id');
  var tbl_ids = tblID.split('_');
  if (tbl_ids[0] == 'REL') {
    filter = tbl_ids[1];
  } else {
    filter = $('#OBJ_' + tblID).val() + "-";
  }

  var additional = $('#ADD_' + tblID).val();

  var id = tr.attr('id');
  var refcode = tr.attr('compcode');
  var isAdded = tr.next().hasClass('SubBounds');
  var trAdd;
  if (!isAdded) {
    tr.after('<div class="SubBounds"></div>');
  }
  trAdd = tr.next();
  if (trAdd.is(':hidden') || !isAdded) {
    trAdd.show();
    $(obj).find('.att_plus\\.png').removeClass('att_plus.png').addClass('att_minus.png');
    trAdd.html('<img src="/images/spinner.gif" />');
    LoadSubRelations(type, trAdd, id, refcode, filter, additional);
  } else {
    trAdd.hide();
    $(obj).find('.att_minus\\.png').removeClass('att_minus.png').addClass('att_plus.png');
  }
}

function RefSelect_GetSelectedValue(item, parent) {
  var RefCode = $(item).data('refcode');
  var RecID = $('#hSelID_' + parent).val();
  if (RecID !== '') {
    var b = RecID.split(';');
    if (b.length == 2) {
      RefCode = b[0];
      RecID = b[1];
    }
    return [RefCode, RecID];
  } else {
    return null;
  }
}

function Reference_OpenRecordInNewWindow(item, parent, viewName) {
  var viewNameParam = viewName ? "&refview=" + viewName : "";
  var v = RefSelect_GetSelectedValue(item, parent);
  window.open("/Reference.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&compcode=" + encodeURI(v[0]) + viewNameParam + "&id=" + v[1] + "&parent=" + parent, 'RefRec' + v[1]);
}

function InputOnMouseOverForShowAddIcons(el, inp, IsShowCreateButton, IsAccessDenied) {
  var me = $(el).closest('.reference_requisite');
  var icons = me.find('.Req_AdditionalIcons');

  var OpenIco = icons.find('.OpenCardIco');
  var CreateRecIco = icons.find('.CreateRecIco');
  var selVal = RefSelect_GetSelectedValue(OpenIco, inp.attr('id'));
  if (selVal != null && selVal !== '*' && !IsAccessDenied && (inp.data('selected') == "true" || inp.data('selected') == "selected" || inp.data('selected') === true) && /^\d+$/.test(selVal[1])) {
    OpenIco.show();
  } else {
    OpenIco.hide();
  }

  if (IsShowCreateButton && !IsAccessDenied && inp.attr('readonly') != 'readonly') {
    CreateRecIco.show();
  } else {
    CreateRecIco.hide();
  }

  icons.show();

  icons.find('.ErrorRecIco').eq(0).attr("title", "Возникла какая-то ошибка");
  icons.find('.ErrorRecIco').show();
}

function InputOnMouseOutForShowAddIcons() {
  $(this).parent().find('.Req_AdditionalIcons').hide().find('p').hide();
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Фильтрация ввода пользователя согласно регулярному выражению====================================================================================== */
(function ($) {
  $.fn.extend({
    Validator: function (regexstr, decimalSeparator) {
      this.each(function () {
        $(this).keypress(function (event) {
          if ($(this).attr('readonly') === 'readonly') return;

          var self = this;
          var code = event.which;
          if (code != 0 && code != 8) {
            var c = String.fromCharCode(code); // определяем какая буква была нажата.
            var docSelection = document.selection;
            if (docSelection) { // для IE<11
              self.focus();
              var Sel = docSelection.createRange();
              var SelLength = docSelection.createRange().text.length;
              Sel.moveStart('character', -self.value.length);
              SelStart = Sel.text.length - SelLength;
              SelEnd = SelStart + SelLength;
              $(event.target).trigger('change');
            } else {
              SelStart = event.target.selectionStart;
              SelEnd = event.target.selectionEnd;
              if (WA.ENV.browser.name == 'IE' && WA.ENV.browser.major == '11') {
                $(event.target).trigger('change');
              }
            }
            //формируем новое значение.
            var val = self.value.substr(0, SelStart) + c + self.value.substr(SelEnd);
            var patt = new RegExp(regexstr);
            if (!patt.test(val)) {
              return false;
            }
            var isIDevice = (/iphone|ipad/gi).test(navigator.appVersion);

            if (decimalSeparator) {
              if (isIDevice) {
                setTimeout(function () {
                  //Lysenko_YN: иначе значения при вводе дублируются. Происходит потому что при вводе значения self.value уже содержит измененное значение а не исходное.
                  val = self.value;
                  $(self).val(val.replace(/[.,]/g, decimalSeparator));
                }, 0);
              }
              else {
                setTimeout(function () { $(self).val(val.replace(/[.,]/g, decimalSeparator)) }, 0);
              }
            }
            return true;
          }
        });
      });
      return this;
    }
  });
})(jQuery);
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Перезагрузка окна после открытия на изменения версии============================================================================================== */
function EditVersion(el, msg) {
  ShowTopSpinner(msg);
  var funcReload;
  if (typeof ReloadVersionList == "undefined")
    funcReload = function () { window.location.reload(); };
  else
    funcReload = ReloadVersionList;
  setTimeout(funcReload, 1000);
}
/*function ReloadVerAddRegion(ID) {
var el = document;
var update_func = function (ID, el) {
//("tr[id=" + ID + "].AddRegion tr[id=ViewList_VersionList]", el).click();
ShowAddRegion($("tr[id=" + ID + "]:first"), true, true);
}
if (ID == null) {
ID = window.name.substring(4);
if (window.opener != null) {
el = window.opener.document;
update_func(ID, el);
}
} else {
setTimeout(function () { update_func(ID, el); }, 1000);
}
}*/
function VerLockOrUnlock(ID, Ver, msg, addArea) {
  var s_res = {};
  ShowTopSpinner(msg);
  var funcReload;
  if (typeof ReloadVersionList == "undefined")
    funcReload = function () { window.location.reload(); };
  else
    funcReload = ReloadVersionList;
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/EDocument.asmx/VersionLockUnlock",
    data: "{'EDocID':'" + ID + "', 'VerNum':'" + Ver + "'}",
    async: false,
    cache: false,
    success: function (res) {
      HideTopSpinner("", 1);
      s_res = res.d;
      if (!CheckForLoginPage(s_res)) {
        if (s_res.Warning == '' && s_res.Error == '') {
          funcReload();
        } else {          
          $.when(WA.FormControlsInit).then(() => {
            WA.CMP.NTF.InlineHint.hideAll();              
            if (s_res.Warning) {
              WA.CR.inlineHint.showWarning(s_res.Warning, null, INLINE_HINT_PRIORITY.PRIMARY);
            } else {
              WA.CR.inlineHint.showError(s_res.Error, null, INLINE_HINT_PRIORITY.PRIMARY);
            }              
          });          
        }
      }
    }
  });
}
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

var oldf = '';
function InitContentListToolbox(cont_id) {
  setInlineHint();
  EnableOrDisableCheckAll();
}

function EnableOrDisableCheckAll() {
  var checkBox = $('#QFilter').find('#chkAll');
  if (checkBox.length) {
    if ($('.List').length > 0) {
      checkBox.attr('disabled', false);
    }
    else checkBox.attr('disabled', true);
  }
}

function clearInlineHint(obj) {
  if (!$.ipad) {
    if ($(obj).hasClass('Req_Gray')) {
      $(obj).val('').removeClass('Req_Gray');
    }
  }
}

function setInlineHint() {
  var labels = L('SEARCH_BY') + " ";
  var filterVariants = $("#QFilter input[id*='FilterVariantsLoc']");
  if (filterVariants.length > 0) {
    var arr = filterVariants.val().split(";");
    for (var i = 0; i < arr.length; i++) {
      labels += arr[i].toLowerCase() + ", ";
    }
    labels = labels.substr(0, labels.length - 2);
    $('#FastSearch').attr('placeholder', labels);
  }
}

function FilterEDMSContent(componentID, filterVal, filterRequisites) {
  WA.CR.objectList.setLikeFilter(filterVal, filterRequisites).reload();

  if (Core.isStatisticEnabled) {
    ///Запись в статистику
    WA.CR.statistics.write({
      page: WA.getLocation(),
      action: "FilterQuery",
      area: 'FilterPanel',
      target: $('#' + componentID).get(0)
    });
  };
}

var g_clipboard = null;

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */


/* = Клиентская сортировка ============================================================================================== */
function LinkClick(el) {
  $("form:first").attr("action", el.href).submit();
}

// Сохранение последнего выбранного объекта.
function SaveLastRun(id) {
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Wizard.asmx/LastRun" + WSSParam,
    data: "{'ID':'" + id + "'}",
    async: false,
    cache: false,
    success: function (res) {
    }
  });
}

/* =================================================================================================================================================== */

/**
 * Получить код ТМа по его ИД.
 *
 * @global
 * @function getStandardRouteCodeByID
 * @param {number} routeID ИД ТМа.
 * @param {function} [successCallback] Callback-функция, выполняемая в случае успешного получения кода записи справочника.
 * @param {function} [failCallback] Callback-функция, выполняемая в случае неудаленого получения кода записи справочника.
 */
function getStandardRouteCodeByID(routeID, successCallback, failCallback) {
  getFilteredRecords(
    'ТМТ',
    `[ИД] = ${routeID}`,
    '',
    ['Код'],
    1,
    0,
    0,
    '',
    successCallback,
    failCallback
  );
}

/**
 * Получить записи справочника.
 *
 * @global
 * @function getFilteredRecords
 * @param {string} referenceCode Код справочника.
 * @param {string} filterExpression Выражение фильтрации.
 * @param {string} filterValue Значение фильтра.
 * @param {array<string>} requisites Список реквизитов для загрузки.
 * @param {number} recordsCount Число записей для выборки.
 * @param {number} startFromRecord Индекс записи, с которой начинается выборка.
 * @param {number} sortIndex Индекс реквизита, по которому производится сортировка.
 * @param {string} sortDirection Направление сортировки.
 * @param {function} [successCallback] Callback-функция, выполняемая в случае успешной выборки записей справочника.
 * @param {function} [failCallback] Callback-функция, выполняемая в случае неудаленого выборки записей справочника.
 */
function getFilteredRecords(referenceCode, filterExpression, filterValue, requisites, recordsCount, startFromRecord, sortIndex, sortDirection, successCallback, failCallback) {
  CallServiceSync('/Reference.asmx/GetRecords', {
    ReferenceCode: referenceCode,
    FilterExpression: filterExpression,
    FilterValue: filterValue,
    Requisites: requisites,
    RecordsCount: recordsCount,
    StartFromRecord: startFromRecord,
    SortIndex: sortIndex,
    SortDirection: sortDirection,
  }, (data) => {
    if (data.Success) {
      if (successCallback instanceof Function) {
        successCallback(data);
      }
    } else {
      if (failCallback instanceof Function) {
        failCallback(data);
      }
    }
  });
}

/**
 * Получить код ТМа по его ИД.
 *
 * @global
 * @function GetStandardRouteCodeByAnalit
 * @param {number} routeID ИД ТМа.
 * @param {function} [successCallback] Callback-функция, выполняемая в случае успешного получения кода записи справочника.
 * @param {function} [failCallback] Callback-функция, выполняемая в случае неудаленого получения кода записи справочника.
 * @deprecated since 5.6. Use getStandardRouteCodeByID instead.
 */
function GetStandardRouteCodeByAnalit(...args) {
  getStandardRouteCodeByID(...args);
}

/**
 * Получить записи справочника.
 *
 * @global
 * @function GetRecordWithFilteredRequisitedByAnalit
 * @param {string} referenceCode Код справочника.
 * @param {string} filterExpression Выражение фильтрации.
 * @param {string} filterValue Значение фильтра.
 * @param {array<string>} requisites Список реквизитов для загрузки.
 * @param {number} recordsCount Число записей для выборки.
 * @param {number} startFromRecord Индекс записи, с которой начинается выборка.
 * @param {number} sortIndex Индекс реквизита, по которому производится сортировка.
 * @param {string} sortDirection Направление сортировки.
 * @param {function} [successCallback] Callback-функция, выполняемая в случае успешной выборки записей справочника.
 * @param {function} [failCallback] Callback-функция, выполняемая в случае неудаленого выборки записей справочника.
 * @deprecated since 5.6. Use getFilteredRecords instead.
 */
function GetRecordWithFilteredRequisitedByAnalit(...args) {
  getFilteredRecords(...args);
}

/* =================================================================================================================================================== */

/* =Пользовательский фильтр ============================================================================================== */

/**
 * Функция выделения элемента из списка обектов
 *
 * @global
 * @function ToggleItem
 * @param {object} jItemCheckBox jQuery-объект чекбокса выделяемого элемента.
 * @param {object} [jItem] jQuery-объект выделяемого элемента списка.
 * @param {bool} [isChecked] True - необходимо выделить элемент, False - снять выделение.
 * @deprecated Use WA.CR.objectList.toggleItem instead.
 */
function ToggleItem(jItemCheckBox, jItem, isChecked) {
  WA.CR.objectList.toggleItem(jItemCheckBox, jItem, isChecked);
}

function ToggleAllItem(el) {
  var inp;
  var isSearchMode = (GetParamInURL('mode') == 'search');
  if ($(el).is(':checked')) {
    if (!isSearchMode) {
      $('.List:not(.selected)').each(function () {
        if ($(this).is(':visible')) {
          inp = $(this).find('input:first').attr('checked', true);
          ToggleItem(inp);
        }
      });
      $(el).attr('title', L('DESELECT_ALL'));
    }
    else {
      $(el).removeAttr('checked').attr('title', L('CANNOT_COPY_ALL_LINKS_IN_SEARCH_RESULTS'));
    }
  }
  else {
    $(".List.selected").each(function () {
      inp = $(this).find('input:first').attr('checked', false);
      ToggleItem(inp);
    });
    $(el).removeClass('notallyet').attr('title', L(isSearchMode ? 'CANNOT_COPY_ALL_LINKS_IN_SEARCH_RESULTS' : 'SELECT_ALL'));
  }
  UpdateCopyPasteIcons();
}

function ToggleAllItemsInComponent(comp_id) {
  var comp = $('#' + comp_id);
  var el = $('#' + comp_id + '_chkAll');

  var inp;
  if (el.is(':checked')) {
    comp.find('.List:not(.selected)').each(
      function () {
        inp = $(this).find('input:first').attr('checked', 'true'); //.show();
        ToggleItem(inp);
      }
    );
    $(el).attr('title', L('DESELECT_ALL'));
  }
  else {
    comp.find('.selected').each(
      function () {
        inp = $(this).find('input:first').attr('checked', ''); //.hide();
        ToggleItem(inp);
      }
    );
    $(el).attr('title', L('SELECT_ALL'));
  }
  UpdateCopyPasteIcons(comp);
  var isChecked = el.is(':checked');
  setTimeout(function () { el.attr('checked', isChecked) }, 0); // WTF fix (something makes another check, so to override this...)
}

// Обновляет иконки (9+)
function UpdateSelectionNumbers() {
  var objList = $('.object_contents:first');
  var num = $('.List.selected', objList).length - (objList.hasClass('ReferenceTable') ? 1 : 0);
  if (num == 0) {
    $('#toolbar_container .selection_numbers_icon_container').remove();
  } else {
    $('#toolbar_container .selection_numbers:not(:has(>.selection_numbers_icon_container))').prepend('<div class="selection_numbers_icon_container" />');
    var cont = $('#toolbar_container .selection_numbers_icon_container');

    // найти все .List:not(.selected) в objList (все элементы с классом List, но без класса selected в objList). Если таких элементов 0 => выбрали все.
    if ($('.List:not(.selected)', objList).length == 0) {
      num = GetRowsCount();
    }

    var title = L('SEND_AS_ATTACHMENT', num);
    if (num > 9) num = 10;
    var iconSrc = format('links_count_{0}.png', num);
    cont.html(format('<p class="{0} selection_numbers_icon" title="{1}" />', iconSrc, title));
  }
}

var UpdateCopyPasteIcons; // устанавливает .disabled у "копировать" и "удалить", если не выбран ни один элемент
(function () {

  function GetButtonsData(comp) {
    return comp.data('copypasteicons') || (function () {
      var res = {};
      res.copy_button = comp.find('div.copy_btn:first');
      if (res.copy_button.length) {
        res.del_button = comp.find('div.delete_btn');
        res.sign_button = comp.find('div.sign_btn');
        res.sign_button_initially_disabled = res.sign_button.hasClass('disabled');
        res.copy_button_initially_disabled = res.copy_button.hasClass('disabled');
        res.del_button_initially_disabled = res.del_button.hasClass('disabled');
        res.copy_button_title = res.copy_button.attr('title');
        res.del_button_title = res.del_button.attr('title');
      }
      comp.data('copypasteicons', res);
      return res;
    })();
  }

  UpdateCopyPasteIcons = function (listReq) {
    var isFilled = false; // ListRequisite из одного объекта. Если там есть объект, то кнопки копировать и удалить все равно работают.
    if (!listReq || !listReq.length) {
      listReq = $('.object_contents:first');
      UpdateSelectionNumbers();
    } else {
      var lr = ListRequisite(listReq.attr('id'));
      isFilled = !lr.IsList && lr.Values && lr.Values.length > 0;
    }
    var b = GetButtonsData(listReq);
    var isListReq = listReq.hasClass('ListRequisite');

    /**
    * Если есть выбранные ссылки указанного типа
    * @inner
    * @function isSelected
    * @return {boolean}
    */
    var isSelected = function (objType) {
      return (listReq.find('.List.' + objType + '_obj.selected').length);
    };

    if (b.copy_button.length) {
      if (isFilled || listReq.find((isListReq ? '' : '>') + '.List.selected').length) {
        if (!b.copy_button_initially_disabled) b.copy_button.removeClass('disabled').attr('title', b.copy_button_title);

        // Отображаем кнопки для подписания всегда, т.к. не знаем, возможно ли запустить агент.
        if (isSelected('Job') || isSelected('EDoc') || isSelected('Task')) {
          if (!b.sign_button_initially_disabled) b.sign_button.removeClass('disabled').attr('title', L('TOOLBAR_LINKS_SIGN_LINK_TOOLTIP'));
        } else {
          b.sign_button.addClass('disabled').attr('title', L("NO_LIST_SELECTION"));
        }

        if (listReq.find((isListReq ? '' : '>') + '.List.selected.cannot_delete').length) {
          if (!b.del_button_initially_disabled) b.del_button.addClass('disabled').attr('title', L("CANNOT_DELETE_ATTACHMENTS_NOT_OWNED"));
        } else {
          if (!b.del_button_initially_disabled) b.del_button.removeClass('disabled').attr('title', b.del_button_title);
        }
      }
      else {
        var reason = L("NO_LIST_SELECTION");
        if (!b.copy_button_initially_disabled) {
          b.copy_button.addClass('disabled').attr('title', reason);
        }
        if (!b.del_button_initially_disabled) {
          b.del_button.addClass('disabled').attr('title', reason);
        }
        if (!b.sign_button_initially_disabled) {
          b.sign_button.addClass('disabled').attr('title', reason);
        }
        //При пустом списке чекбокс недизейблился
        EnableOrDisableCheckAll();
      }
    }
  };

})();

/////////////////////////////// ListRequisite ////////////////////////////////////////////////////////////////////////

let updateChkAll = (comp, chkAll) => {
  let allCheckBoxes = comp.find('input.chk');
  let checkedBoxes = allCheckBoxes.filter(':checked');    
  // Получаем общее количество объектов: для содержимого папок и поисков - это общее количество всех элементов, 
  // для остальных - загруженные объекты
  let allCheckBoxCount = GetRowsCount() || allCheckBoxes.length;  
  // Устанавливаем Выделить все, только если выделены все записи.
  if (checkedBoxes.length === +allCheckBoxCount) {
    if (!GetParamInURL('searchname')) {
      chkAll.attr('checked', '1').attr('title', L('DESELECT_ALL'));
    }
  } else {
    chkAll.removeClass('notallyet').removeAttr('checked').attr('title', L('SELECT_ALL'));
  }
};

function ToggleFolderItem($this) {
  var chk;
  if ($this.hasClass('chk')) {
    chk = $this;
  } else {
    if ($this.hasClass('Icon32')) {
      chk = $this.parent().find('input.chk:first');
    } else {
      chk = $this.find('input.chk:first');
    }
  }
  ToggleItem(chk);
}

// Инициализирует компоненту EntityList.
function EntityListInit(_comp, allowSelect, enableActions) {
  var comp = _comp;
  var tr = comp.children('div.folder_item');
  comp.children('div:odd').addClass('even');

  // Что бы обновить кнопки, в том числе, когда ничего не найдено.
  UpdateCopyPasteIcons(listReq);

  if (tr.length == 0)
    return;

  var el0 = $(tr[0]);
  if ($.scrollActive && WA.ENV.isAndroid() && _comp.hasClass('object_contents')) {
    var h = _comp.offset().top + _comp.height() + 50;
    _comp.css('margin-bottom', '-50px');
    setRealHeightAndWidth(null, h);
    $.superHeight = true;
  }
  if (!el0.data('initialized')) {
    el0.data('initialized', '1');
    InitObjectContentsAutoLoad();
  }

  var listReq = _comp.parents('.ListRequisite');
  var chkAll = $("#" + listReq.attr('id') + "_chkAll");
  if (chkAll.length == 0) {
    comp = comp.parents(':has(#chkAll)');
    chkAll = comp.find('#chkAll');
  }

  /**
  * Обработчики того, что произойдет при клике на строку списка
  */
  var eventHandler = function () {

    /**
    * @function updateSelection
    * @private
    */
    var _updateSelection = function () {
      updateChkAll(_comp, chkAll.addClass('notallyet'));
      UpdateCopyPasteIcons(listReq);
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Помечает элемент выборанным
    * @function _selectItem
    * @param {Object} jItem - элемент списка. В данном случае tr.
    * @private
    */
    var _selectItem = function (jItem) {
      ToggleFolderItem(jItem);
      _updateSelection();
      jItem.redraw();
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выбор элемента при клике на него, открытие документа при клике на иконку
    * @function bindSelectItems
    */
    this.bindSelectAndOpenItems = function (jItems) {
      if (allowSelect) {
        jItems.unbind('mousedown.entitylist').bind('mousedown.entitylist', ev => {
          const jItem = $(ev.target);
          const classes = jItem.attr('class').split(' ');
          // если клик по resizable контролу грида, уходим отсюда
          if (classes.includes('ui-resizable-e')) {
            return;
          }
          if (ev.which === 1) {
            ev.stopPropagation();
            _selectItem(jItem.closest('.object-list-item'));
          }
        });
        StopSelectOnIconClick(jItems.find('.object-list-item__bound-expand-icon, .object-list-item__icon'));
      }
      InitEDocIconClick(jItems.find('.object-list-item__icon'));
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _comp.data('updateSelection', _updateSelection);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  var handler = new eventHandler();

  // Отображение/скрытие действий (по умолчанию отображаем).
  if (enableActions) {
    InitShowHideActions(tr);
  }

  InitHover(tr);

  handler.bindSelectAndOpenItems(tr);

  tr.unbind('contextmenu.entitylist').bind('contextmenu.entitylist', function (e) {
    e.preventDefault();
    e.stopPropagation();
    ShowContextMenu($(this), {}, { 'left': e.pageX, 'top': e.pageY }, true);

    //Обновляем доступность кнопок для элементов списка, так как rightClick сам не провоцирует
    UpdateCopyPasteIcons(listReq);
    return false;
  });

  if (listReq.length) {
    var lr = ListRequisite(listReq.attr('id'));
    if (lr.onUpdate) lr.onUpdate.call(lr);
  }

  InitTooltips();
}

function InitListClick(trs) {
  trs.unbind('mousedown.entitylist').bind('mousedown.entitylist', function (ev) {
    ev.stopPropagation();
    var $this = $(this);
    ToggleFolderItem($this);
    updateChkAll($this.parent(), $('#chkAll').addClass('notallyet'));
  });
  StopSelectOnIconClick(trs.find(".object-list-item__bound-expand-icon, .object-list-item__icon"));
  InitEDocIconClick(trs.find(".object-list-item__icon"));
}

// Предотвратить выделение галочкой при нажатии
function StopSelectOnIconClick(jIcons) {
  jIcons
    .off('mousedown.entitylist')
    .on('mousedown.entitylist', function (ev) {
      // Предотвращаем выделение галочкой.
      ev.stopPropagation();
    });
}

function InitEDocIconClick(jIcons) {
  // При нажатии на иконку документа открывать документа, предотвратить выделение галочкой
  jIcons
    .off('click.entitylist')
    .on('click.entitylist', function (ev) {
      ev.stopPropagation();
      let jObjectListItemTitle = $(this).closest('.object-list-item').find('.object-list-item__title');
      DoFirstAction(jObjectListItemTitle, jObjectListItemTitle.data('type'));
    });
}

function InitHover(trs) {
  if ($.ipad) return;
  var hoverEventNames = GetEventsName('hover_entitylist');
  trs
    .unbind(hoverEventNames[0]).bind(hoverEventNames[0], function (ev, isManualTriggered) {
      if (!isKeyNavigationActive || isManualTriggered) {
        $('.List.hover').removeClass('hover');
        $(this).addClass('hover');
      }
    })
    .unbind(hoverEventNames[1]).bind(hoverEventNames[1], function (ev, isManualTriggered) {
      if (!isKeyNavigationActive || isManualTriggered) {
        $(this).removeClass('hover');
      }
    });
}

function InitShowHideActions(trs) {
  if (!$.ipad) {
    trs.each(function () {
      var $this = $(this);
      $this
        .unbind('mouseenter.animate_entitylist').bind('mouseenter.animate_entitylist', function (ev, isManualTriggered) {
          if (!isKeyNavigationActive || isManualTriggered) {
            EntityList_ShowAction($this, trs);
          }
        })
        .unbind('mouseleave.animate_entitylist').bind('mouseleave.animate_entitylist', function (ev, isManualTriggered) {
          if (!isKeyNavigationActive || isManualTriggered) {
            EntityList_HideAction($this);
          }
        });
    });
  }
}

var dbg_is_hover = false;

// Отображение действий для элемента списка.
function EntityList_ShowAction(el, trs) {
  // Формирует панель быстрыъ действий.
  function MakeActions(el) {
    if (typeof listActionsSettings != 'undefined') {
      var objKindMap = { "edoc": "EDocument", "task": "Task", "job": "Job", "fol": "Folder", "ref": "ReferenceRecord", "usr": "UserSettings", 'ver': 'EDocumentVersion' };
      var proxy = GetObjectInfoFromRow(el);
      var objKind = proxy.kind.toLowerCase();
      proxy.type = objKindMap[objKind];

      var sett;
      var mode = proxy.tr.attr('mode');
      switch (mode) {
        case 'EDocRestore':
          sett = listActionsSettings['EDocRestore'];
          break;
        case 'OpenedDocs':
          sett = listActionsSettings['OpenedDocs'];
          break;
        default:
          sett = listActionsSettings[proxy.type];
      }

      if (sett) {
        // Выберем только те действия, которые нужно показать.
        var actions = _.filter(sett.items.slice(0), function (item) { return item.needshow ? window[item.needshow](proxy) : true });
        if (actions.length > 0) {
          if (objKind == 'edoc' && mode != 'EDocRestore' && mode != 'OpenedDocs') {
            SetPreviewActionFirst(actions);
            if (g_isPreviewEnabled) SortEditActionsByPriority(actions);
          }
          var actionsHTML = '<div class="fastActions">';
          for (var i = 0; i < actions.length; i++) {
            var item = actions[i];
            // Формируем так что бы все параметры были в одинарных кавычках ($.toJSON делает все в двойных)
            var objStr = "{'id\':" + proxy.id +
              ", 'kind':'" + proxy.kind +
              "', 'type':'" + proxy.kind +
              "', 'refcode':'" + (typeof proxy.refcode == 'undefined' ? '' : proxy.refcode) +
              "', 'version':'" + proxy.tr.attr('version') +
              "', 'encodeType':'" + (!!proxy.tr.attr('encoding') ? proxy.tr.attr('encoding') : "") +
              "', 'pluginName' : '" + (!!proxy.tr.attr('encpluginname') ? proxy.tr.attr('encpluginname') : "") +
              "'}";

            // Формируем гиперссылку, если нужно.
            var hyperlink = MakeActionListItemHyperlink(item, proxy);

            // Формируем текст ссылки.
            var text = L(item.text);
            if (objKind == 'job' && item.id == 'MarkAsRead') {
              if (!el.hasClass('unread')) {
                text = L('MENU_MARK_AS_UNREAD');
              } else {
                text = L('MENU_MARK_AS_READ');
              }
            }
            // Формируем ссылку (быстрое действие).
            var ITEM_IMG_TEMPLATE = '<img class="fastActions__item" src="{icon}" />';
            var iconHtml = (typeof item.icon !== 'undefined') ? format(ITEM_IMG_TEMPLATE, { icon: item.icon }) : '';
            actionsHTML += format('<a data-name="{name}" title="{title}" href="{href}" {target} onclick="{stopPropagation}{js}{retFalse}">{img}</a>', {
              'img': iconHtml,
              'name': item.id,
              'href': (hyperlink != '' ? hyperlink : '#'),
              'target': (item.innewwindow == 'True' ? ('target="' + proxy.kind + proxy.id + '" ') : ' target="_self" '),
              'stopPropagation': 'if(typeof evt != \'undefined\') evt.stopPropagation(); else { cancelBubble(event); };',
              'js': (typeof item.jsaction != 'undefined' ? '(function(CurrentActionHTMLElement) {{ ' + item.jsaction + ' }}).call(' + objStr + ',this);' : ''),
              'retFalse': (hyperlink != '' ? '' : 'return false;'),
              'title': text
            });
          }
          return actionsHTML + '</div>';
        }
      }
    }
    return "";
  }


  var content = $(el).addClass('showingActions').find('.content');
  if (!isKeyNavigationActive && content.length > 0) {
    // Формируем html-код действий.
    var actionsHTML = MakeActions(el);
    if (actionsHTML != '') {
      content.append(actionsHTML);
      content.find('.fastActions').show();
    }
  }
}

// ставит действие по умолчанию при нажатии на название документа на первое место в быстрых действиях
function SetPreviewActionFirst(actions) {
  //var defaultAction = g_isPreviewEnabled ? 'preview' : (g_openDocForEditByDefault ? 'open' : 'viewineditor');
  if (actions[0].id.toLowerCase() != g_defaultListAction) {
    for (var i = 0; i < actions.length; i++) {
      if (actions[i].id.toLowerCase() == g_defaultListAction) {
        var temp = actions[i];
        actions[i] = actions[0];
        actions[0] = temp;
        break;
      }
    }
  }
}

function SortEditActionsByPriority(actions) {
  var defaultAction = 'open';//(g_openDocForEditByDefault ? 'open' : 'viewineditor');
  var secondAction = 'viewineditor';//(!g_openDocForEditByDefault ? 'open' : 'viewineditor');
  for (var i = 0; i < actions.length; i++) {
    if (actions[i].id.toLowerCase() == defaultAction && i > 0 && actions[i - 1].id.toLowerCase() == secondAction) {
      var temp = actions[i];
      actions[i] = actions[i - 1];
      actions[i - 1] = temp;
      break;
    }
  }

}

function DoNotShowInSearchResults() {
  return !Core.toolBars.main.isSearchMode();
}

function DoNotShowWhenAgentEnabled() {
  return !WA.agent.isAvailable();
}

function ShowWhenAgentEnabled() {
  return WA.agent.isAvailable();
}

function IsDocOpenedForEditByDefault() {
  return ShowWhenAgentEnabled() && g_openDocForEditByDefault;
}

function IsDocOpenedForReadByDefault() {
  return ShowWhenAgentEnabled() && !g_openDocForEditByDefault;
}

function IsIsDocOpenedForEditByDefaultAndPreviewDisabled() {
  return IsDocOpenedForEditByDefault() && !g_isPreviewEnabled;
}

function IsIsDocOpenedForReadByDefaultAndPreviewDisabled() {
  return IsDocOpenedForReadByDefault() && !g_isPreviewEnabled;
}

function IsRecoverActionsAvailable(proxy) {
  return $(proxy.tr.context).hasClass('list-item__doc_to-recover');
}

function IsReturnActionAvailable(proxy) {
  return $(proxy.tr.context).hasClass('list-item__doc_edited');
}

function IsOpenActionsAvailable(proxy) {
  var jContext = $(proxy.tr.context);
  return jContext.hasClass('list-item__doc_edited') || jContext.hasClass('list-item__doc_no-change');
}


// Скрытие действий для элемента списка.
function EntityList_HideAction(el) {
  var $el = $(el);
  if ($el.hasClass('showingActions') && !$el.hasClass('menu_select')) {
    $(el).removeClass('showingActions').find('.fastActions').remove();
  }
}

// Получить список выделенных объектов.
function GetSelectedObjects() {
  var selected = WA.CR.objectList.getSelectedItems();
  return _(selected).map(function (item) {
    return {
      id: item.id,
      kind: item.kind,
      refcode: item.referenceName ? item.referenceName : ''
    };
  });
}

// Инициализация автоподгрузки в списке объектов.
function InitObjectContentsAutoLoad(filterVal, filterRequisites) {
  var browser = WA.ENV.browser.name.toLowerCase();

  var MinBottomDistanceToStartAutoLoad = 150; // пикселей

  function BindOnScroll(obj) {
    if ($.superHeight || WA.ENV.isAndroid()) {
      $.when(WA.ObjectListInit).done(function () {
        if (_(WA.CR.objectList.getItems()).size() >= EXPLORER.MAX_OBJECT_ROWS_COUNT) {
          // Если длина списка >= MAX_OBJECT_ROWS_COUNT, то отобразим ссылку "Показать больше объектов".
          if (!$('.main-content__load-more').length) {
            var $loadbtn = $('<div class="main-content__load-more">' + L('AUTO_LOAD_MORE') + '</div>').click(function () {
              $.when(WA.ObjectListInit).done(function () {
                AutoLoad(obj);
              });
              $loadbtn.remove();
            });
            obj.append($loadbtn);
          }
        } else {
          // Иначе удалим эту ссылку "Показать больше объектов", т.к. загружать больше нечего и так ничего нет.
          $('.main-content__load-more').remove();
        }
      });
    } else {
      var mc = obj.parents('#main_container');
      var scroller = mc;
      mc.unbind('scroll.auto_load').bind('scroll.auto_load', function () {
        if ($.scrollActive) {
          var bottomDistance = obj[0].offsetHeight - scroller[0].offsetHeight - scroller.offset().top + obj.offset().top;
        } else {
          if (browser === 'ie') {
            var bottomDistance = obj.height() - scroller.height() - scroller.scrollTop();
          } else {
            var bottomDistance = obj[0].offsetHeight - scroller[0].offsetHeight - scroller[0].scrollTop;
          }
        }
        if (bottomDistance <= MinBottomDistanceToStartAutoLoad) {
          mc.unbind('scroll.auto_load');
          $.when(WA.ObjectListInit).done(function () {
            AutoLoad(obj);
          });
        }
      });
    }
  }

  function AutoLoad(obj) {
    const page = obj.data('nextPage') || 2;    
    obj.data('nextPage', page + 1);

    const folderId = WA.CR.getID();

    if (filterVal && filterRequisites) {
      WA.CR.objectList.setLikeFilter(filterVal, filterRequisites);
    }

    removeSpinningThingy();

    const jSpinningThingy = $('<div class="object-list-load-spinner spinner"></div>');
    const jSpinnerIcon = $('<svg class="spinner__icon"><use xlink:href="#loading-16"/></svg>');
    const jSpinnerText = $('<span class="spinner__text"></span>').html(
      L('PLEASE_WAIT')
    );
    jSpinningThingy.append(jSpinnerIcon).append(jSpinnerText);
    jSpinningThingy.appendTo(obj);
    obj.data('spinningThingy', jSpinningThingy);

    function removeSpinningThingy() {
      if (obj.data('spinningThingy')) {
        obj.data('spinningThingy').remove();
        obj.data('spinningThingy', null);
      }
    }

    // Запомним невыделенные записи, чтобы при дозагрузке они не выделились
    let unselectedLinks = WA.CR.objectList.getUnselectedItems();
      
    WA.CR.objectList._loadPage(folderId, page).done((res) => {
      removeSpinningThingy();
      if (!CheckForLoginPage(res)) {
        const count = obj.children('div.List').length;
        obj.append(res);
        EntityListInit(obj, true);
        if ($.scrollActive && window.mainScroll) {
          mainScroll.refresh();
        }
        setTimeout(() => {
          let objs = obj.children('div.List');
          if (objs.length > count) {
            BindOnScroll(obj);
          } else {
            if (objs.length > g_MaxRowsPerPage) {
              let jAutoLoadNoMore = $('.main-content__all-loaded', obj);
              if (!jAutoLoadNoMore.length) {
                $('<div class="main-content__all-loaded">' + L('NO_MORE_ITEMS') + '</div>').appendTo(obj);
              }
              else {
                jAutoLoadNoMore.show();
              }
            }
            $('.main-content__load-more').hide();
          }

          if (WA.ObjectListInit.state() === 'resolved' && !!WA.CR.objectList && WA.CR.objectList.isAllItemsSelected()) {             
            let isUnselected = (jItem) => {                                     
              return unselectedLinks.some((unselectedLink) => {
                let sameId = +unselectedLink.id === +jItem.attr('id');
                let sameKind = unselectedLink.kind.toLowerCase() === jItem.attr('kind').toLowerCase();
                return sameId && sameKind;
              });
            }
            
            // Отмечаем как выделенные, только вновь загруженные строки
            objs.not('.selected').each((index, item) => {                                
              let jItem = $(item);
              if (!unselectedLinks.length || !isUnselected(jItem)) { 
                let jcheckBox = jItem.find('input')                
                WA.CR.objectList.toggleItem(jcheckBox, jItem, true);                  
              }                
            });
          }

          UpdateRowsCount();
          Core.pages.explorer.updateOrApplyGridOptions(folderId);

          /**
          * Чтобы прокрутка на iPad проходила до конца списка
          * @see Замечание 78037
          */
          if ($.scrollActive && window.mainScroll) {
            mainScroll.refresh();
          }

          //Обновим объект клиентской ОМ
          if (WA.ObjectListInit.state() === 'resolved' && !!WA.CR.objectList) {
            WA.CR.objectList.fire('itemsChange');
          }
        }, 0);
      }
    }).fail(() => {
      removeSpinningThingy();
    });
  }

  $('.object_contents.auto_load').each(function () {
    var $this = $(this);
    $this.data('AutoLoad', function () {
      $.when(WA.ObjectListInit).done(function () {
        AutoLoad($this);
      });
    });
    BindOnScroll($this);
  });
}

function ExplorerInitialScroll(initialItemsCount, itemsOnPage) {
  var obj = $('.object_contents.auto_load');
  if (obj.length) {
    var nextPage = (itemsOnPage === 0) ? 1 : Math.ceil(initialItemsCount / itemsOnPage) + 1;
    obj.data('nextPage', nextPage);
    var initScroll = parseInt($.cookie('load_scroll'), 10);
    if (initScroll) {
      setTimeout(function () {
        obj.parents('#main_container').scrollTop(initScroll);
      }, 0);
    }
  }
}

function enableButtonAddInListRequisite(idListReq, data) {
  if (data != null) {
    if (data.length != 0) {
      $('#' + idListReq).find('button').removeClass('disabled').removeAttr('disabled');
    }
  } else {
    $('#' + idListReq).find('button').addClass('disabled').attr('disabled', 'diasabled');
  }
}
// Функции для реквизита "Список объектов".
var ListRequisite;
(function () {

  // Кэш объектов ListRequisiteClass.
  var controls = {};

  // Возвращает объект для работы с ListRequisite.
  // string id: ClientID объекта
  ListRequisite = function (id) {
    if (!id) {
      return {};
    } else if (id === 'ctl00_MainContent_Attachments_AttachmentsList' || id === 'Attachments_AttachmentsList_list') {
      // где-то остался старый id контейнера, соединим их
      id = 'Attachments_AttachmentsList';
    }

    if (!controls.hasOwnProperty(id)) {
      controls[id] = new ListRequisiteClass(id);
      if (!controls[id].elem) {
        controls[id].elem = $(`#${id}`);
      }
    }

    const list = controls[id];
    if (list.elem && !list.elem.length) {
      list.elem = $(list.elem.selector);
    }
    return list;
  };

  // Класс для работы с ListRequisite.
  function ListRequisiteClass(id) {
    this.id = id;
  }

  ListRequisiteClass.prototype = {

    AjaxInProcess: false,

    // Инициализирует объект.
    // string param.ContentKind: тип объектов в списке
    // bool param.ReadOnly: реквизит только для чтения
    // string param.RefCode: код справочника
    // bool param.IsList: если true, то это список, иначе это 1 объект
    // array param.Values: массив ссылок на объекты
    Init: function (param) {
      var me = this;
      $.extend(me, param);
      me.elem = $('#' + me.id);
      me.Values = $.parseJSON(me.Values);
      var valJSON = $.toJSON(me.Values);
      $('#' + me.id + "_data").val(valJSON);
      me.AjaxInProcess = false;
      if (param.OnLoad) {
        var onLoadFunc = new Function(param.OnLoad);
        onLoadFunc.call(me);
      }
      UpdateCopyPasteIcons(me.elem);
    },

    Disable: function () {
      var me = this;
      me.elem.find('.ListRequisiteOuterPanel').addClass('readonly')
        .find('.paste_btn, .cut_btn, .delete_btn').hide();
      me.elem.find('.ListRequisite__addReferencePanel').hide();
      me.ReadOnly = true;
    },

    Enable: function () {
      var me = this;
      me.elem.find('.ListRequisiteOuterPanel').removeClass('readonly')
        .find('.paste_btn, .delete_btn').show();
      me.elem.find('.ListRequisite__addReferencePanel').show();
      me.ReadOnly = false;
    },

    /**
    * Подписывает выбранные ссылки
    * @method ListRequisie#SignLinks
    * @param callback: функция обратного вызова для обработанной ссылки.
    * @param completeMsg: сообщение о завершении операции.
    * @since 5.1.0.1505
    * @return {ListRequisie}
    */
    SignLinks: function (callback, completeMsg) {
      var me = this;
      var links = me.GetSelectedLinks();
      if (links.hrefs != '') {

        Core.agent.getPlugin('CryptographyPlugin').done(() => {
          Core.objectList.signLinks(_.map(links.links, function (link) {
            var newLinkWithName = $.extend({}, link);
            // GetSelectedLinks возвращает ссылки, в которых в поле Desc написано наименование объекта, но для отображения ошибок нужно свойство name.
            newLinkWithName["name"] = newLinkWithName["Desc"];
            delete newLinkWithName["Desc"];
            return newLinkWithName;
          }));
        });

      } else {
        (new WA.CMP.NTF.Toast).show(L("OBJECTS_NOT_SELECTED"));
      }
      return this;
    },

    /**
     * Копирует выделенные ссылки в буфер.
     *
     * @param {function} callback функция обратного вызова для обработанной ссылки.
     * @param {string} completeMsg сообщение о завершении операции.
     */
    CopyLinks: function (callback, completeMsg) {
      var me = this;

      setLinksSource(null, null);

      me.ShowSpinner(L("COPY_LINKS"));

      var linkContainer = me.GetSelectedLinks();
      if (linkContainer.hrefs != '') {
        var linkModels = linkContainer.links;
        var apiLinks = convertLinkModelsToAgentLinks(linkModels);
        Core.clipboard.copyLinksToClipboard(apiLinks).done(function (copiedLinksCount) {
          me.HideSpinner(L("COPIED_LINKS", copiedLinksCount), 2000);
        }).fail(function (completeMsg) {
          me.HideSpinner(completeMsg, 2000);
        });
      } else {
        me.ShowSpinner(L("OBJECTS_NOT_SELECTED"), 2000);
      }
    },

    /**
     * Вставляет ссылки в список объектов (с проверкой соответствия).
     *
     * @param {function} callback функция обратного вызова для обработанной ссылки.
     * @param {string} completeMsg сообщение о завершении операции.
     */
    PasteLinks: function (callback, completeMsg) {
      var me = this;

      if (me.ReadOnly) return;

      if (!me.AjaxInProcess) {
        me.AjaxInProcess = true;
        setLinksSource(null, null);
        me.ShowSpinner(L("PASTE_LINKS"));
        if (!me.IsAttachments) {
          WebAccess.agent.isPluginAvailable("Clipboard").always(function (isAvailableResponse) {
            // HACK: Агент неадекватно работает в IE. Поэтому все вставки ссылок будут идти через Session.asmx.
            if ((isAvailableResponse) && (WA.ENV.browser.name != "IE")) {
              Core.clipboard.getLinksFromClipboard().done(function (links) {
                me.AddLinks(links, me, callback, completeMsg);
                me.AjaxInProcess = false;
              });
            } else {
              CallService("/Session.asmx/GetLinksFromBuffer",
                null,
                function (res) {
                  if (res.Success) {
                    var links = res.Result;
                    me.AddLinks(links, me, callback, completeMsg);
                  } else {
                    me.HideSpinner(res.Error, 5000);
                  }
                  me.AjaxInProcess = false;
                },
                function () {
                  me.AjaxInProcess = false;
                });
            }
          }
          );
        } else {
          var oldCount = me.Values.length;
          var svcParams = {
            ClientID: me.id + "_list",
            CustomWorkID: me.CustomWorkID,
            CustomWorkType: me.CustomWorkType
          };

          var callServiceToPaste = function (svcMethodName, svcParams) {
            me.CallMyService(svcMethodName,
              svcParams,
              function (res) {
                me.RenderList(res);

                var newCount = me.Values.length;
                var pasteCount = newCount - oldCount;
                if (pasteCount > 0) {
                  me.elem.trigger('change', me.Values);
                  if (completeMsg === "" || !(completeMsg))
                    me.HideSpinner(L("PASTED_LINKS", pasteCount), 2000);
                  else
                    me.HideSpinner(completeMsg, 2000);
                  EnableOrDisableCheckAll();
                } else {
                  me.HideSpinner(L("NOT_LINKS_TO_PASTE"), 2000);
                }
                if (callback) callback(res);
                me.AjaxInProcess = false;
              },
              function (x, e1, e2) {
                me.AjaxInProcess = false;
              });
          };

          WebAccess.agent.isPluginAvailable("Clipboard").always(function (isAvailableResponse) {
            if (isAvailableResponse) {
              Core.clipboard.getLinksFromClipboard()
                .done(function (links) {
                  $.extend(svcParams, { Links: links });
                  callServiceToPaste("PasteLinks", svcParams);
                }).fail(function () {
                  callServiceToPaste("PasteAttachments", svcParams);
                });
            } else {
              callServiceToPaste("PasteAttachments", svcParams);
            }
          });
        }
      }
    },

    // Добавляет ссылки в список.
    // @param callback: функция обратного вызова для обработанной ссылки.
    // @param completeMsg: сообщение о завершении операции.
    AddLinks: function (links, me, callback, completeMsg) {
      var me = this;
      if (me.ReadOnly) return;

      var counter = 0;
      if (links) {
        $.each(links, function () {
          //Проверяем на соответствие объекта списку
          if (me.CheckObject(this)) {
            //Проверяем вставился ли объект в список
            if ((!callback) || (callback(this))) {
              me.AddObject(this);
              counter += 1;
              return me.IsList;
            }
          }
        });
      }
      if (counter > 0) {
        me.UpdateList(function () {
          if (completeMsg === "")
            me.HideSpinner(L("PASTED_LINKS", counter), 2000);
          else
            me.HideSpinner(completeMsg, 2000);
        });
      } else {
        me.HideSpinner(L("NOT_LINKS_TO_PASTE"), 2000);
      }
    },

    // Удаляет выделенные ссылки из списка объектов.
    // @param callback: функция обратного вызова для обработанной ссылки.
    // @param completeMsg: сообщение о завершении операции.
    DeleteLinks: function (links, callback, completeMsg) {
      var me = this;
      if (me.ReadOnly) return;

      var me = this;
      if (!me.AjaxInProcess) {
        if (!links) {
          var sel = me.GetSelectedLinks();
          if (sel.cannotDelete)
            return;
          links = sel.links;
        }
        var oldCount = me.Values.length;
        if ((links) && (links.length > 0)) {
          ConfirmDelete(links.length, me.IsAttachments ? (links.length > 1 ? L("CONFIRM_DELETE_ATTACHMENTS", links.length) : L("CONFIRM_DELETE_ATTACHMENT")) : null).done(function () {

            me.AjaxInProcess = true;
            if (!me.IsAttachments) {
              var ids = $.map(links, function (link) { return parseInt(link.ID, 10) });
              me.Values = $.grep(me.Values, function (v) { return $.inArray(v.ID, ids) == -1; });
              var newCount = me.Values.length;
              var delCount = oldCount - newCount;
              if (delCount > 0) {
                me.ShowSpinner(L("DELETE_LINKS"));
                me.UpdateList(function () {
                  if (completeMsg === "")
                    me.HideSpinner(L("DELETED_LINKS", delCount), 2000);
                  else
                    me.HideSpinner(completeMsg, 2000);
                  me.AjaxInProcess = false;
                });
                if (callback) $.each(links, function (index, link) { callback(link); });
              }
            } else {
              me.ShowSpinner(L("DELETE_LINKS"));

              WA.SRV.call('/ListRequisite.asmx/DeleteAttachments', {
                ClientID: me.id + "_list",
                CustomWorkID: me.CustomWorkID,
                CustomWorkType: me.CustomWorkType,
                ValuesJSON: $.toJSON(links)
              }, null, null, true, true).done(function (res, obj) {
                me.RenderList(res);
                var newCount = me.Values.length;
                var delCount = oldCount - newCount;
                if (completeMsg === "")
                  me.HideSpinner(L("DELETED_LINKS", delCount), 2000);
                else
                  me.HideSpinner(completeMsg, 2000);
                EnableOrDisableCheckAll();
                me.AjaxInProcess = false;
                //Отобразить сообщение
                if (obj.Warning) {
                  var errorStr = JSON.parse(obj.Warning);
                  if (errorStr.mainText) {
                    var dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
                    dialog.showWarning(errorStr.mainText, errorStr.additionalText.replace('\n', '<br/><br/>'));
                  }
                }
              }).fail(function (e) {
                me.AjaxInProcess = false;
                //Отобразить сообщение
                var dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
                dialog.showError(e);
              });
            }

          });
        } else {
          //me.ShowSpinner(L("OBJECTS_NOT_SELECTED"), 2000);
        }
      }
    },

    DeleteLink: function (obj, callback, msg) {
      var me = this;
      if (me.ReadOnly) return;

      this.DeleteLinks([{ ID: obj.id, Kind: obj.kind, CompCode: obj.refcode || '' }], callback, msg);
    },

    // Удаляет все ссылки из списка объектов.
    Clear: function (callback) {
      var me = this;
      if (me.ReadOnly) return;

      var me = this;
      if (!me.AjaxInProcess) {
        me.AjaxInProcess = true;

        if (callback) {
          $.each(me.Values, function () { callback(this); });
        }

        me.Values = [];
        me.UpdateList(function () {
          me.AjaxInProcess = false;
        });
      }
    },

    // Добавляет выбранную запись справочника.
    // string input_id: ID контроля выбор из справочника.
    AddRefRec: function (input_id) {
      var me = this;
      if (me.ReadOnly) return;

      var add_id;
      try {
        add_id = parseInt($("#hSelID_" + input_id).val(), 10);
      } catch (e) {
        add_id = 0;
      }
      if (add_id) {
        var req = $("#" + input_id).data();
        req.ReferenceSelectInstance.setValue();

        // Lysenko_YN: EnableSameRecords - если установлено в false, то одну и туже запись добавить несколько раз нельзя
        if ((me.EnableSameRecords === false) || (me.elem && (me.elem.attr('data-enableSameRecords') == 'false'))) {
          if ($.grep(me.Values, function (v) { return v.ID == add_id }).length == 0) {
            me.AddRefRecToList(add_id);
          }
        } else { //Шамов А.: По обращению 75532 - что бы можно было дабавлять одну и туже запись справочника несколько раз.
          me.AddRefRecToList(add_id);
        }
      }
    },

    //Добавляет запись в список
    AddRefRecToList: function (add_id) {
      var me = this;
      if (me.ReadOnly) return;

      var newObj = { ID: add_id, Kind: "REF", CompCode: me.RefCode };
      if (me.IsList) {
        me.Values.push(newObj);
      } else {
        me.Values = [newObj];
      };
      me.ShowSpinner(L("PLEASE_WAIT"));
      me.UpdateList(function () {
        me.HideSpinner("", 0);
      });
    },


    InitAttachments: function (CustomWorkID, CustomWorkType) {
      this.IsAttachments = true;
      this.CustomWorkID = CustomWorkID;
      this.CustomWorkType = CustomWorkType;
      var att = this.elem.parents('.attachments');
      var cont = att.parents('.attachments_container');

      var me = this;
      me.elem.find('div.ListRequisiteList')
        .attr('kind', 'att')
        .bind('contextmenu', function (e) {
          e.preventDefault();
          e.stopPropagation();
          ShowContextMenu($(this), {}, { 'left': e.pageX, 'top': e.pageY }, true);
          return false;
        });
    },

    SetCannotDelete: function (ids) {
      var me = this;
      $.each(ids, function () {
        var row = $('#' + this + '.folder_item:not(.cannot_delete)', me.elem);
        if (row.length)
          row.addClass('cannot_delete');
      });
    },

    //////////////// PRIVATE /////////////////////////////

    // Возвращает список выбранных объектов.
    // return object:
    //   string .hrefs: ссылки в текстовом виде для вставки в буфер.
    //   array .links: массив объектов для передачи сервису.
    GetSelectedLinks: function () {
      if (!this.IsList)
        return GetSelectedID(this.elem.find('.folder_item'));
      else {
        var items = this.elem.find('.folder_item.selected');
        var res = GetSelectedID(items);
        if (items.filter('.cannot_delete').length) {
          res.cannotDelete = true;
        }
        return res;
      }
    },


    GetLinks: function () {
      if (!this.IsList)
        return GetSelectedID(this.elem.find('.folder_item'));
      else {
        var items = this.elem.find('.folder_item');
        var res = GetSelectedID(items);
        if (items.filter('.cannot_delete').length) {
          res.cannotDelete = true;
        }
        return res;
      }
    },

    // Показывает информационное сообщение.
    // string msg: сообщение
    // [int delay]: если указано, то сообщение пропадет через delay миллисекунд
    ShowSpinner: function (msg, delay) {
      if (delay) {
        ShowTopSpinnerResult(msg, delay);
      } else {
        ShowTopSpinner(msg);
      }
    },

    // Показывает информационное сообщение о завершении действия. Если до этого панель спиннера была спрятана, нужно использовать ShowSpinner.
    // string msg: сообщение
    // int delay: задержка в миллисекундах
    HideSpinner: function (msg, delay) {
      HideTopSpinner(msg, delay);
    },

    // Обновляет список объектов с сервера. Также сохраняет Values в скрытое поле.
    // [function callback()]: вызывается после обновления списка
    UpdateList: function (callback) {
      var me = this;

      var valJSON = $.toJSON(me.Values);
      $('#' + me.id + "_data").val(valJSON);
      me.CallMyService("UpdateList", {
        ClientID: me.id + "_list",
        ContentKind: me.ContentKind,
        RefCode: me.RefCode,
        IsList: me.IsList,
        ShowScrollBar: me.ShowScrollBar,
        Values: valJSON,
        EmptyText: me.EmptyText || '',
        IsShowActions: me.IsShowActions
      }, function (res) {
        me.RenderList(res);
        if (typeof callback !== "undefined")
          callback.call(me);
      });
      EnableOrDisableCheckAll();
    },

    RenderList: function (res) {
      var me = this;
      if (res.NewValues != null) {

        me.Values = $.parseJSON(res.NewValues);
        $('#' + me.id + "_data").val(res.NewValues);
      }
      var listContainer = $('#' + me.id + '_list');
      listContainer.empty();
      if (me.ShowScrollBar && me.Values.length > 3) {
        listContainer.addClass('ListRequisiteScroller');
      } else {
        listContainer.removeClass('ListRequisiteScroller');
      }
      if (res.HTML) listContainer.html(res.HTML);
      if (res.InitJS) eval(res.InitJS);
      $('#' + me.id + "_chkAll").removeAttr('checked').attr('title', L('SELECT_ALL'));
      try { // Только для мастеров!
        ProcessEmptyChecks();
      } catch (e) { }
      UpdateCopyPasteIcons(this.elem);
      me.elem.trigger('change');
    },

    // Вызывает метод сервиса ListRequisite.
    // string method: метод
    // [object params]: передаваемые параметры
    // [function callback(res)]: функция, вызываемая при успешном результате (result.Success == true)
    //     object res: результат (result.Result)
    CallMyService: function (method, params, callback, errorCallback) {
      var me = this;
      CallService("/ListRequisite.asmx/" + method, params, function (res) {
        if (res.Success) {
          if (typeof callback !== "undefined")
            callback.call(me, res.Result);
        }
        else {
          me.ShowSpinner("Во время операции произошла ошибка. Обратитесь к администратору.", 5000);
        }
      }, errorCallback);
    },

    // Проверяет объект на соответстие списку.
    // object obj: объект
    //   int obj.ID: ИД объекта
    //   string obj.Kind: тип объекта
    //   string obj.CompCode: код справочника
    // return bool: соответствует ли объект списку
    CheckObject: function (obj) {
      obj.Kind = obj.Kind.toUpperCase();
      if (this.ContentKind != "ANY" &&
        (obj.Kind != this.ContentKind ||
          obj.Kind == "REF" && obj.CompCode != this.RefCode)) {
        return false;
      }
      return ($.grep(this.Values, function (v) { return v.ID == obj.ID; }).length == 0);
    },

    // Добавляет объект в список.
    // object obj: объект
    //   int obj.ID: ИД объекта
    //   string obj.Kind: тип объекта
    //   string obj.CompCode: код справочника
    AddObject: function (obj) {
      obj.Kind = obj.Kind.toUpperCase();
      var newObj = { ID: obj.ID, Kind: obj.Kind.toUpperCase(), CompCode: obj.CompCode };
      if (this.IsList) {
        this.Values.push(newObj);
      } else {
        this.Values = [newObj];
      }
    }
  };

})();

// Список валидаторов.
var g_EmptyCheckFunc = [];

// Добавляет валидатор для контроля.
//   [jQuerySet control]: контроль, на события которого вешается операция проверки валидности.
//   function func(): функция-валидатор.
function RegisterEmptyCheck(control, func) {
  g_EmptyCheckFunc.push(func);
  if (control) {
    var events = ['blur', 'click', 'change', 'keyup'];
    for (var i = 0; i < events.length; ++i) {
      try {
        control[events[i]](ProcessEmptyChecks);
      }
      catch (e) { }
    }
  }
}

// Выполняет валидацию контролей на странице.
function ProcessEmptyChecks() {
  // При выборе из справочника значения еще может не быть. Например, такое бывает если выбираешь из "Избранных и последних" в выборе пользователей. #107229
  setTimeout(function () {
    var ok = true;
    for (var i = 0; i < g_EmptyCheckFunc.length; ++i) {
      if (!g_EmptyCheckFunc[i]()) {
        ok = false;
        break;
      }
    }
    $('.next_button').each(function () {
      var init;
      var disabled;
      init = $(this).data('initial_disabled');
      if (!init) {
        init = ($(this).attr('disabled') || $(this).attr('disabled') === "") ? "y" : "n";
        $(this).data('initial_disabled', init);
      }

      disabled = (ok ? (init == "y") : true);
      if (disabled) {
        $(this).attr('disabled', 'disabled').addClass("disabled");
      } else {
        $(this).removeAttr('disabled').removeClass("disabled");
      }
    });
  }, 100);
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */


/* = Карточка справочника ============================================================================================================================ */

function scrollbarWidth() {
  var div = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');
  // Append our div, do our calculation and then remove it
  $('body:first').append(div);
  var w1 = $('div', div).innerWidth();
  div.css('overflow-y', 'scroll');
  var w2 = $('div', div).innerWidth();
  $(div).remove();
  return (w1 - w2);
}

function Reference_SelectRecord(el) {
  var chk = $(el);
  var tr = chk.parents('.List:first');
  if (chk.is(':checked')) {
    tr.addClass('selected');
  } else {
    tr.removeClass('selected');
  }
  updateChkAll(tr.parent(), $('#chkAll').addClass('notallyet'));
  UpdateCopyPasteIcons();
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Поля поиска
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function InitSearchField() {
  $('.explorer-search-input').focus(function () {
    var me = $(this);
    if (!me.hasClass('Search_FilledField')) {
      // Стираем текущий текст, только если это общий поиск.
      if (me.attr("id") == "SrchQuickText")
        me.val('');
      me.addClass('Search_FilledField');
    }
  })
    .blur(function () {
      var me = $(this);
      if (me.val() == '') {
        me.val(me.data('empty'));
        me.removeClass('Search_FilledField');
      }
    }).each(function () {
      var me = $(this);
      if (me.data('empty') && (me.val() == '' || me.val() == me.data('empty')))
        me.val(me.data('empty'));
      else
        me.addClass('Search_FilledField');
    });
}

//////////////////// Компонента "список версий" /////////////////////////////////////////

// Генерирует функцию, осуществляющую загрузку с сервера списка версий.
// controlID - id контроля списка
// EDocID - id документа
// ErrorClientID - id контроля Error
function GenReloadVersionList(controlID, EDocID, ErrorClientID) {
  return function () {
    $.ajax({
      type: "GET",
      dataType: "html",
      url: format("DynControl.ashx?c=versions&EDocID={0}&ErrorClientID={1}", EDocID, ErrorClientID),
      success: function (res) {
        if (!CheckForLoginPage(res)) {
          $('#' + controlID).html(res);
          HideTopSpinner();
        }
      },
      error: function (err) {
        HideTopSpinner(err, 5000);
      },
      cache: false
    });
  };
}

// Показывает дерево "Папки" в левой панели.
function ShowFolderTree(el) {
  ClearSelectedElements(el);
  SetElementToolBar(el);
  $('#Tree').show().find(".FolderTreeDiv").show();
  if (window.UpdateFolderTreeScroll) UpdateFolderTreeScroll();
}

//Определяет, является ли папка targetFolder вложенной относительно sourceFolder (targetFolder и sourceFolder = fpath из url = id li)
function isChildFolder(sourceFolderPath, targetFolderPath, currentFolderPath) {
  /*
  tp = "1-2-3-4-5-";
  sp = "1-2-";
  tp.split(sp).indexOf("") == 0; => isChildFolder
  */
  var arr = targetFolderPath.split(sourceFolderPath);
  return (arr.length > 1 && arr.indexOf("") == 1 && currentFolderPath != sourceFolderPath);
}

// определяет, что dragEl - корневая папка (Favorites, Outbox, Inbox, Common)
function isRootFolder(dragEl) {
  return ($(dragEl).parent().parent().parent("ul.treeview").length == 1);
}

// Инициализирует меню по правой кнопке в компоненте для построения связанных документов/записей справочника.
function InitContextMenuForBound(trs) {
  if (!trs) trs = $('.List');
  trs
    .unbind('contextmenu.bound').bind('contextmenu.bound', function (e) {
      ShowContextMenu($(this).children(), {}, { 'left': e.pageX, 'top': e.pageY });
      return false;
    });
}

// Инициализирует реквизит типа "флажок".
function InitCheckboxRequisite(el) {
  //setTimeout(function () {
  var displayControl = $(format('#{0}_display', el.attr('id')), el);
  var valueControl = $(format('#{0}_value', el.attr('id')), el);
  el.data('requisite').val = function (value) {
    if (typeof value !== 'undefined') {
      displayControl.prop('checked', value == el.data('requisite').yes);
      valueControl.val(value);
    } else {
      return valueControl.val();
    }
  };
  displayControl.bind('click change', function () {
    if (displayControl.is(':checked')) {
      valueControl.val(el.data('requisite').yes);
    } else {
      valueControl.val(el.data('requisite').no);
    }
  });
  //}, 0);
}

function getHintDataObj(el) {
  return (typeof el.data("data-hint") == 'undefined' ? eval("(" + el.attr("data-hint") + ")") : el.data("data-hint")); //FIXME: eval
}


let g_addinfo = [];
/**
* Навешивает подсказку по доп. реквизитам на элемент.
*
* @function AttachTooltipToElement
* @param {Object} el - текущий элемент.
* @param {Object} ev - событие.
* @param {boolean} [opt_showAfterAttach = true] - признак показыватьли после привязки.
* @param {Object} [opt_showOptions  = {}] - параметры показа.
* @param {Object} [opt_positionOptions  = {}] - позиция.
*/
function AttachTooltipToElement(el, ev, opt_showAfterAttach = true, opt_showOptions = {}, opt_positionOptions = {}) {
  // Получение содержимого подсказки.
  const getContent = function (el, callback) {
    const dataobject = getHintDataObj(el); //есть два поля: id и compcode
      if (dataobject.id && dataobject.compcode) {
        const params = {
          RefCode: dataobject.compcode,
          RecID: dataobject.id,
        };
        CallService('/Reference.asmx/GetAdditionalInfoForAllRecords', params, res => {
          if (res.Success) {
            el.qtip("enable");
            el.qtip.zindex = 130000;

            const uniqueIndex = `${dataobject.compcode}_${dataobject.id}`;
            g_addinfo[uniqueIndex] = res.Result;

            if (res.Result[0].Requisites.length) {
              GenerateAdditionalInfoTooltipHtml(res.Result[0], 0, res.Result.length).done((html) => {
                if (html) {
                  if (callback) callback(html);
                } else {
                  el.qtip("disable");
                }
              });
            }
          } else {
            el.qtip("disable");
          }
        });
      }
  };

  // Если уже навесили подсказку, больше этого не делаем.
  if (!el.hasClass('hintInit')) {
    getContent(el, function (hintContent) {
      hintContent = $(hintContent);
      // Событие по крестику для закрытия хинта.
      hintContent.find('i').bind('click.hint', function () {
        el.qtip('hide', ev);
      });
      el.addClass('hintInit').qtip('destroy').qtip({
        style: { classes: "ui-tooltip-light ui-tooltip-shadow ui-tooltip-rounded" },
        show: $.extend({
          effect: false,
          solo: true,
          delay: 800,
        }, opt_showOptions),
        content: { text: hintContent },
        hide: {
          effect: false,
          fixed: true, 
          delay: 100,
          leave: false,
        },
        position: $.extend({
          viewport: $(window),
          effect: false,
          target: 'mouse',
          adjust: {
            mouse: false,
            x: 15,
            y: 0,
          },
          my: 'bottom left',
          at: 'bottom left',
        }, opt_positionOptions),
        events: {
          show: function (event, api) {
            if (!el.is(':visible')) {
              event.preventDefault();
            }
          }
        }
      });
      if (opt_showAfterAttach) el.qtip('show', ev);
    });
  }
};

let hintTimeout;
/**
* Функция для инициализации подсказок по допреквизитам.
*
* @function InitAdditionalInfoTooltip
* @param {Object} el - текущий элемент.
* @param {number} [opt_position] - позиция.
*/
function InitAdditionalInfoTooltip(el, opt_position) {
  const me = el;
  if (!$.ipad) {
    me.unbind('mouseenter.hint').bind('mouseenter.hint', function (ev) {
      var $this = $(this);
      if (hintTimeout) clearTimeout(hintTimeout);
      hintTimeout = setTimeout(function () {
        AttachTooltipToElement($this, ev, true, undefined, opt_position);
      }, 800);
    }).unbind('mouseleave.hint').bind('mouseleave.hint', function () {
      if (hintTimeout) clearTimeout(hintTimeout);
    });
  }
}

/**
* Генерирует подсказку к объекту системы.
*
* @function GenerateAdditionalInfoTooltipHtml
* @param hint - информация для подсказки.
* @param page - номер страницы в подсказке.
* @param pagesCount - всего страниц.
* @return html шаблон подсказки.
*/
function GenerateAdditionalInfoTooltipHtml(hint, page, pagesCount) {
  let reqs = [];
  let btnPrevClass = '';
  let btnNextClass = '';
  for (let i = 0; i < hint.Requisites.length; i++) {
    reqs.push({
      Class: (i === 0 ? 'first' : ''),
      Caption: (hint.Requisites[i].Caption || ''),
      Href: hint.Requisites[i].Href,
      Text: hint.Requisites[i].Text,
      HasImage: (hint.Requisites[i].Href !== null),
    });
  }

  if ((page === 0) && (pagesCount > 1)) {
    btnPrevClass = 'disabled';
  }

  if (page === pagesCount-1) {
    btnNextClass = 'disabled';
  }

  const params = WA.TMPL.prepare({
    HasImage: !!hint.Image,
    ImageSRC: hint.Image,
    Style: (hint.Image ? 'style="left:120px;"' : ''),
    Requisites: reqs,
    PageIndex: page,
    ButtonPrevClass: btnPrevClass,
    ButtonNextClass: btnNextClass,
    HasButtons: (pagesCount > 1),
  });
  return WA.TMPL.render('referenceRecords/objectTooltip.html', params);
}

/**
* Получение предыдущей подсказки в информации об объекте.
*
* @function changeInfo
* @param {Object} btn - текущая кнопка.
* @param {boolean} isPrev - TRUE - если текущая кнопка это кнопка 'Назад', иначе - FALSE.
*/
function changeInfo(btn, isPrev) {
  const jCurrentButton = $(btn);
  if (jCurrentButton.hasClass('disabled')) {
    return;
  }

  let index = parseInt(jCurrentButton.data('pageindex'));

  if (isPrev) {
    index--;
  } else {
    index++;
  }
  
  const jQtip = jCurrentButton.parents('.qtip');
  const currentButtonHintSelector  = `[aria-describedby='${jQtip[0].id}']`;
  const jCurrentButtonHint = $(currentButtonHintSelector);
  let dataobject = getHintDataObj(jCurrentButtonHint);
  const uniqueIndex = `${dataobject.compcode}_${dataobject.id}`;
  const info = g_addinfo[uniqueIndex];

  GenerateAdditionalInfoTooltipHtml(info[index], index, info.length).done(html => {
    if (html) {
      //отрендерить
      jCurrentButtonHint.qtip('option', 'content.text', html);
    }
  });
}